/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} User_Detail_Left_Out_Unknown_RoundsInputs */



/**
* | output |
* | --- |
* | "{count} event(s) left out of the per-game figures: round count unknown." |
*
* @param {User_Detail_Left_Out_Unknown_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_left_out_unknown_rounds = /** @type {((inputs: User_Detail_Left_Out_Unknown_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Left_Out_Unknown_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} tournoi(s) exclu(s) des chiffres par partie : nombre de rondes inconnu.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} torneo(s) excluido(s) de las cifras por partida: número de rondas desconocido.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} torneio(s) fora dos números por partida: número de rodadas desconhecido.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} torneo/i escluso/i dalle cifre per partita: numero di turni sconosciuto.`)
	return /** @type {LocalizedString} */ (`${i?.count} event(s) left out of the per-game figures: round count unknown.`)
});